var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "38px",
    viewBox: "0 0 37 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Yacopini---Territorio---Home-Copy",
    transform: "translate(-1142.000000, -2007.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 1409.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 556.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(1101.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(42.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7347294,35.6470588 L5.71567059,35.6470588 C2.60202353,35.6470588 0.0784941176,33.1228235 0.0784941176,30.0091765 L0.0784941176,5.99082353 C0.0784941176,2.87717647 2.60202353,0.352941176 5.71567059,0.352941176 L29.7347294,0.352941176 C32.8483765,0.352941176 35.3726118,2.87717647 35.3726118,5.99082353 L35.3726118,30.0091765 C35.3726118,33.1228235 32.8483765,35.6470588 29.7347294,35.6470588 Z",
    id: "Stroke-1",
    stroke: "#292727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0986118,35.3386588 L21.0986118,23.1847765 L25.1779059,23.1847765 L25.7892,18.4483059 L21.0986118,18.4483059 L21.0986118,15.4243059 C21.0986118,14.0527765 21.4790824,13.1181882 23.4456706,13.1181882 L25.9543765,13.1174824 L25.9543765,8.88077647 C25.5202588,8.82289412 24.0315529,8.69371765 22.2993176,8.69371765 C18.6830824,8.69371765 16.2075529,10.9017176 16.2075529,14.9548941 L16.2075529,18.4483059 L12.1169647,18.4483059 L12.1169647,23.1847765 L16.2075529,23.1847765 L16.2075529,35.3386588",
    id: "Fill-3",
    fill: "#292727"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.620e8c52f053dd00345ad1497c0d7143.svg";
export { ForwardRef as ReactComponent };